import {
    forwardRef,
    useImperativeHandle,
    useState,
} from 'react'

import { Country } from 'country-state-city'

const countries = Country.getAllCountries()

const CountryInput = forwardRef(({ data }, ref) => {

    const [selectedCountry, setSelectedCountry] = useState(data?.country ?? "United States")
    const [countryError, setCountryError] = useState()

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {

            const isValid = countries.some(country => country.name === selectedCountry)

            if (!isValid) {
                setCountryError(true)
            }

            return {
                isValid,
                value: {
                    country: selectedCountry,
                },
            }
        },
    }))

    return (
        <div ref={ref}>
            <div className="text-left">
                <label
                    className="block text-sm text-gray-800 mb-2"
                    htmlFor="country"
                >
                    Country
                </label>
                <select
                    id="country"
                    name="country"
                    className="border border-gray-300 rounded-md p-2 bg-white w-full"
                    value={selectedCountry}
                    onChange={e => {
                        setSelectedCountry(e.target.value)
                        setCountryError(undefined)
                    }}
                >
                    <option value="">Select Country</option>
                    {countries.map(country => (
                        <option key={country.name} value={country.name}>
                            {country.name}
                        </option>
                    ))}
                </select>

                {countryError && (
                    <p className="text-sm text-red-600 mt-2">Please select country</p>
                )}
            </div>
        </div>
    )
})

export default CountryInput
